// src/index.ts
import { registerPlugin } from '@capacitor/core';
const Myket = registerPlugin('Myket');
export * from './definitions';
export { Myket };
//# sourceMappingURL=index.js.map